import { Icon, Text } from '@betterment/samba-react';
import { Flex } from '@betterment/style-closet-react';

const SecureInfoBadge = () => {
  return (
    <Flex alignItems="center">
      <Flex mr="1">
        <Icon name="SecurityCheck" size="small" color="icon.weak" />
      </Flex>
      <Text
        as="p"
        color="text.weak"
        css={{
          fontSize: 'fontSize.50',
          margin: 'space.0',
        }}
      >
        All your information is secure.
      </Text>
    </Flex>
  );
};
export default SecureInfoBadge;
